import React from 'react';
import { Header, Label, List, Segment, Table } from 'semantic-ui-react';
import { Programming } from '../../models/programming';
import {
    formatDeviationMinutes,
    getTripClosureFromProgramming,
} from '../../utils/programming-trip-closure';
import {
    formatActualUtcAsSaoPaulo,
    formatProgrammingDateTime,
} from '../../utils/programming-timeline-utils';

interface ProgrammingTripClosureSummaryProps {
    programming: Programming;
    compact?: boolean;
}

const ProgrammingTripClosureSummary: React.FC<ProgrammingTripClosureSummaryProps> = ({
    programming,
    compact = false,
}) => {
    const closure = getTripClosureFromProgramming(programming);

    if (!closure?.stages?.length) {
        return (
            <Segment secondary>
                <Header as="h4">Resumo da viagem</Header>
                <p>Sem dados de fechamento para esta programação.</p>
            </Segment>
        );
    }

    return (
        <Segment secondary>
            <Header as="h4">Resumo da viagem</Header>
            {closure.finalStatusLabel && (
                <Label
                    color={closure.finishedWithDelay ? 'orange' : 'green'}
                    style={{ marginBottom: '0.75rem' }}
                >
                    {closure.finalStatusLabel}
                </Label>
            )}
            {closure.intermediateDelayNotes?.length > 0 && (
                <List bulleted size={compact ? 'small' : 'medium'}>
                    {closure.intermediateDelayNotes.map(note => (
                        <List.Item key={note}>{note}</List.Item>
                    ))}
                </List>
            )}
            <Table compact={compact} celled size="small">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Etapa</Table.HeaderCell>
                        <Table.HeaderCell>Planejado</Table.HeaderCell>
                        <Table.HeaderCell>Real</Table.HeaderCell>
                        <Table.HeaderCell>Desvio (min)</Table.HeaderCell>
                        <Table.HeaderCell>Parado (min)</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {closure.stages.map(stage => (
                        <Table.Row key={stage.key}>
                            <Table.Cell>{stage.label}</Table.Cell>
                            <Table.Cell>{formatProgrammingDateTime(stage.plannedAtUtc)}</Table.Cell>
                            <Table.Cell>{formatActualUtcAsSaoPaulo(stage.actualAtUtc)}</Table.Cell>
                            <Table.Cell>{formatDeviationMinutes(stage.deviationMinutes)}</Table.Cell>
                            <Table.Cell>
                                {stage.dwellMinutes != null ? stage.dwellMinutes : '—'}
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </Segment>
    );
};

export default ProgrammingTripClosureSummary;
